import(/* webpackMode: "eager" */ "/codebuild/output/src3114885563/src/next-app/app/global-error.tsx");
